import {Button, Space, Table, Tag} from "antd";
import {useEffect} from "react";
import {EyeOutlined} from "@ant-design/icons";
import dayjs from "dayjs";
import {CHANGE_REQUEST_RECORD_STATUS, NOT_AVAILABLE, YYYY_MM_DD_HH_MM} from "../../../util/Constants";


interface ChangeRequestHistoryTableProp {
    tableData: any[] | undefined
    onShowModal: (data: any) => any
    loading: boolean

}

const ChangeRequestHistoryTableComp = (props: ChangeRequestHistoryTableProp) => {

    useEffect(() => {
    }, []);

    const columns = [
        {
            title: 'Reference ID',
            dataIndex: 'complaintId',
            sorter: (a: any, b: any) => (a.complaintId - b.complaintId) || (a.id - b.id)|| (a.groupId - b.groupId),
            render: (text: any, rec: any) => (
                <span>{text || rec.id|| rec.groupId}</span>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'recordStatus',
            key: 'recordStatus',
            align: 'center',
            sorter: (a: any, b: any) => {
                a = a.recordStatus == null ? '' : a.recordStatus
                b = b.recordStatus == null ? '' : b.recordStatus
                return a.localeCompare(b);
            },
            render: (text: any, rec: any) => {
                return (
                    <Tag className={'drl-tbl-tag'}
                         color={getColor(text)} key={text}>
                        {text.toUpperCase()}
                    </Tag>
                )
            }
        },
        {
            title: 'Request Date',
            dataIndex: 'createdDate',
            key: 'createdDate',
            defaultSortOrder: 'descend',
            sorter: (a: any, b: any) => {
                a = a.createdDate == null ? '' : a.createdDate
                b = b.createdDate == null ? '' : b.createdDate
                return a.localeCompare(b);
            },
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Action',
            key: 'action',
            align: "center",
            fixed: 'right' as const,
            render: (rec: any) => (
                <Space size="middle">
                    <Button className='btn-action-outline-common btn-action-view '
                            onClick={() => showModal(rec)}
                            icon={<EyeOutlined/>}>View</Button>
                </Space>
            ),
        },
    ];

    const showModal = (record: any) => {
        props.onShowModal(record)
    }
    const getColor = (identificationSourceType: string) => {
        switch (identificationSourceType) {
            case CHANGE_REQUEST_RECORD_STATUS.ACCEPTED: {
                return 'green';
            }
            case CHANGE_REQUEST_RECORD_STATUS.SUBMITTED: {
                return '#faad14';
            }
            case CHANGE_REQUEST_RECORD_STATUS.REJECTED: {
                return '#cf1322';
            }
            case CHANGE_REQUEST_RECORD_STATUS.CANCELLED: {
                return '#dfd3d4';
            }
        }
    }


    return (
        <>
            <Table size='small' dataSource={props.tableData} columns={columns} scroll={{x: 'max-content'}}
                   loading={props.loading}></Table>
        </>
    )
}
export default ChangeRequestHistoryTableComp;